import http from '@/plugins/http.js';
import Vue from 'vue';
import { IsNull } from '@/utils/utils';

export default {
    entBaseInfo: null,
    entOrganizationInfo: null,
    sysSetting: null,
    /// 获取logo
    async getLogoImage() {
        await http.loadAppJson();
        return Vue.prototype.$apiURL + '/api/System/GetEntLogoImg/EntLogo';
    },
    /// 获取登录背景图
    async getLgoinBackgroundImage() {
        await http.loadAppJson();
        return Vue.prototype.$apiURL + '/api/System/GetEntLogoImg/LoginLogo';
    },
    //获取企业信息
    async getEntBaseInfo() {
        if (!this.entBaseInfo) {
            const res = await http.GET('api/System/GetEntBaseInfo');
            if (res.Success) {
                this.entBaseInfo = res.Result;
                return this.entBaseInfo;
            }
        } else {
            return Promise.resolve(this.entBaseInfo);
        }
    },
    //获取企业信息
    getMessageSet() {
        return http.GET('api/System/GetMessageSet');
    },
    //保存消息设置
    saveMessageSet(parameters) {
        return http.POST('api/System/SaveMessageSet', parameters);
    },
    // 获取企业信息
    async getEntOrganizationInfo() {
        if (!this.entOrganizationInfo) {
            const res = await http.GET('api/System/GetEntOrganizationInfo');
            if (res.Success) {
                this.entOrganizationInfo = res.Result;
                return this.entOrganizationInfo;
            }
        } else {
            return Promise.resolve(this.entOrganizationInfo);
        }
    },
    // 获取企业配置中心数据
    GetSettingCenterInfo() {
        return http.GET('api/System/GetSettingCenter');
    },
    GetLicenseSignSetting() {
        return http.GET(`api/System/GetLicenseSignSetting`);
    },
    SaveLicenseSignSetting(license) {
        return http.POST(`api/System/SaveLicenseSignSetting`, license);
    },
    getSettingCenter() {
        return http.GET(`api/System/GetSettingCenter`);
    },
    //保存系统参数和组织同步
    saveCustomSetting(param) {
        return http.POST(`api/System/SaveCustomSetting`, param);
    },
    getCustomSettingValue() {
        return http.GET('api/System/GetCustomSettingValue');
    },
    async getSystemSetting() {
        if (!this.sysSetting) {
            const res = await http.GET('api/System/GetSystemSetting');
            if (res.Success) {
                this.sysSetting = res.Result;
                return this.sysSetting;
            }
        } else {
            return Promise.resolve(this.sysSetting);
        }
    },
    getThirdPartyAuth(objectId) {
        return http.GET(`api/System/GetThirdPartyAuth/${objectId}`);
    },
    deleteThirdPartyAuth(objectId) {
        return http.GET(`api/System/DeleteThirdPartyAuth/${objectId}`);
    },
    getAllThirdPartyAuths() {
        return http.GET(`api/System/GetAllThirdPartyAuths`);
    },
    thirdSystemNameExist(systemName, objectId) {
        let api = `api/System/ThirdSystemNameExist/${systemName}`;
        if (!IsNull(objectId)) {
            api += `/${objectId}`;
        }
        return http.GET(api);
    },
    thirdSystemCodeExist(systemCode, objectId) {
        let api = `api/System/ThirdSystemCodeExist/${systemCode}`;
        if (!IsNull(objectId)) {
            api += `/${objectId}`;
        }
        return http.GET(api);
    },
    addThirdPartyAuth(thirdPartyAuth) {
        return http.POST('api/System/AddThirdPartyAuth', thirdPartyAuth);
    },
    updateThirdPartyAuth(thirdPartyAuth) {
        return http.POST('api/System/UpdateThirdPartyAuth', thirdPartyAuth);
    },
    createRSAKey() {
        return http.GET(`api/System/CreateRSAKey`);
    },
};
